import { MopedElectricIcon } from './MopedElectricIcon';

/**
 * author: Google
 * id 5DA43EA9-3DE7-49D8-8884-BB4D8ED31305
 * name moped-electric
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/moped-electric.svg
 * tags
 * - Transportation + Road 
 */
export const VespaElectricIcon = MopedElectricIcon;
export default VespaElectricIcon